import { render } from "./VoiceChatScreen.vue?vue&type=template&id=bca1c5fe"
import script from "./VoiceChatScreen.vue?vue&type=script&lang=js"
export * from "./VoiceChatScreen.vue?vue&type=script&lang=js"

import "./VoiceChatScreen.vue?vue&type=style&index=0&id=bca1c5fe&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__